import InvestorContainer from './investor_container';

const Investor = InvestorContainer;
export default Investor;
